import React from 'react';

export default function FaqPage() {
    return (
        <section id="body">
            <div className="container">
                <div className="row shadow title position-relative">
                    <div className="col-12">
                        <h2 className="text-center m-5 text-white font-weight-bold">Frequently Asked Questions</h2>
                    </div>
                </div>
                <div className="row content">
                    <div className="col-1"></div>
                    <div className="col-10 shadow bg-white rounded">
                        <div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">1.</label>
								<label className="col-10 col-form-label">
									How much premium do I have to pay?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									The total premium amount you will have to pay depends on the sum insured and/or according to the plan you select.
									Minimum premium depends on the selection the insurance company is applicable to the Section 1 (Houseowner) and 
									Section 2 (Householder) total premium.
									Premium Payment can be made via Cash, Credit Card, Internet Banking and Cheque.
								</label>
							</div>
						</div>
                        <div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">2.</label>
								<label className="col-10 col-form-label">
								What are some of the key terms and conditions that I should be aware of?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									<ol type="a">
										<li>
											<b>Importance of Disclosure</b><br></br>
											Pursuant to Paragraph 5 of Schedule 9 of the Financial Services Act 2013, if you are applying for this Insurance
											wholly for purposes unrelated to your trade, business or profession, you have a duty to take reasonable care not
											to make a misrepresentation in answering the questions in the Proposal Form (or when you apply for this insurance).
											You must answer the questions fully and accurately.
											Failure to take reasonable care in answering the questions may result in avoidance of your contract of insurance,
											refusal or reduction of your claim(s), change of terms or termination of your contract of insurance.
											The above duty of disclosure shall continue until the time your contract of insurance is entered into, varied or renewed with us.
											In addition to answering the questions in the Proposal Form (or when you apply for this insurance), you are required to disclose any other matter that you know to be relevant to our decision in accepting the risks and determining the rates and terms to be applied.
											You also have a duty to tell us immediately if at any time after your contract of insurance has been entered into, varied or renewed with us any of the information given in the Proposal Form (or when you applied for this insurance) is inaccurate or has changed.
										</li>
										<li>
											<b>Duty of Assured</b><br></br>
											You should take all reasonable precautions to prevent claim incidents.
										</li>
										<li>
											<b>Premium Warranty</b><br></br>
											You must pay the premium and the premium must be received by the insurer within sixty (60) days from the policy/ endorsement/renewal certificate inception date.
										</li>
										<li>
											<b>Submission of Claim</b><br></br>
											In the event of a claim, you are required to notify us within thirty (30) days from the date of the accident and submit the relevant documents within fourteen (14) days thereof
										</li>
										<li>
											<b>Insured Value/Sum Insured</b><br></br>
											You must ensure that your property is insured at the appropriate amount taking into account the renovations made to your property. If the amount insured in your policy is less than the actual value at the time of loss (i.e. under-insurance), you are deemed to be self-insuring the difference. This average condition will apply in the event of a claim.
											You may use the PIAM Building Cost Calculator (BCC) to guide you in determining the Sum Insured for your residential properties. You may access the BCC via our https://instapol.my/ or PIAM’s website at www.piam.org.my.
											Excesses, being the amount you have to bear before we indemnify you, are applicable for certain perils, such as overflowing of domestic water tanks, windstorm, earthquake and flood claims.
										</li>
										<li>
											<b>Policy Expiry</b><br></br>
											Unless renewed, coverage will cease upon policy expiry date.<br></br>
											(Note: Please refer to the policy wording for the full terms and conditions of this policy.)
										</li>
									</ol>
								</label>
							</div>
						</div>
                        <div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">3.</label>
								<label className="col-10 col-form-label">
									What are the major exclusions under this policy?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									This policy does not cover certain losses such as:
									<ul>
										<li> Loss / damage due to subsidence, landslip, riot, strike and malicious damage: unless with additional premium</li>
										<li> War, Civil War and any Act of Terrorism</li>
										<li>Radioactive and Nuclear Energy Risks</li>
										<li>Date recognition</li>
										<li>Property Damage to data or software</li>
										<li>Loss of damage by burst pipes whilst the building is untenanted</li>
									</ul>
									(Note: This list is non-exhaustive. Please refer to the policy contract for the full list of exclusions under this policy.)
								</label>
							</div>
						</div>
                        <div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">4.</label>
								<label className="col-10 col-form-label">
									Can I cancel my policy?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									You may cancel your policy at any time by giving written notice to us in which case we shall retain the customary short period rate for the time the policy has been in force. Upon cancellation, you are entitled to a refund premium subject to the minimum premium to be retained by the company. No refund of premium will be allowed if there is a claim under the policy.
								</label>
							</div>
						</div>
                        <div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">5.</label>
								<label className="col-10 col-form-label">
									Is there any after sales & claims services offered to customer after insurance purchase?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									Yes, instaPol from Howden provides (1) Product Advisory, offering ongoing support to clients regarding insurance-related queries post-purchase (2) Assistance in changing / updating policy details (3) Claims assistance.  Alternatively, you may also contact your chosen insurance company or takaful operator.
								</label>
							</div>
						</div>
                        <div className="question">
							<div className="row text-primary font-weight-bold">
								<label className="col-1 col-form-label text-center">6.</label>
								<label className="col-10 col-form-label">
									Can I purchase this product directly from the insurance company / takaful operator?								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									Yes, you may purchase insurance / takaful directly from any insurer or takaful operator by visiting their nearest branch or through their website.								</label>
							</div>
						</div>

                    </div>
                    <div className="col-1"></div>
                </div>
            </div>
            <div className="row footer">
                <div className="col-12 text-right mt-2">
                    <a className="btn btn-success mr-3" href="/Landing">Return to Home Page</a>
                    <a className="btn btn-success" href="/Landing">Get Quote</a>
                </div>
            </div>
        </section>
    );
}